(function() {
  const SERUM_ID = 8068073488696;
  const MASCARA_ID = 10496899187000;

  async function checkAndRemoveGift() {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    
    const serumItem = cart.items.find(i => i.product_id === SERUM_ID);
    const mascaraItem = cart.items.find(i => i.product_id === MASCARA_ID && i.price === 0);
    
    if (mascaraItem && (!serumItem || serumItem.quantity < 2)) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: mascaraItem.key, quantity: 0 })
      });
      window.location.reload();
    }
  }

  document.addEventListener('change', (e) => {
    if (e.target.matches('[name="updates[]"]') || e.target.matches('quantity-input')) {
      setTimeout(checkAndRemoveGift, 800);
    }
  });

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-action="reduce"]') || 
        e.target.closest('.cart-remove-button') ||
        e.target.closest('[class*="remove"]')) {
      setTimeout(checkAndRemoveGift, 800);
    }
  });
})();